import React from 'react';
import LedgerBug from './LedgerBug';

interface BrandLockupProps {
  /** Ledger Bug mark size in pixels. */
  size?: number;
  /** Wordmark font size in pixels — fixed, not viewport-relative, so it never wraps mid-word in a constrained nav/footer container. */
  wordSize?: number;
  className?: string;
}

/** Horizontal lockup — Ledger Bug + "2 Girls 1 Parlay" wordmark, single line. */
const BrandLockup: React.FC<BrandLockupProps> = ({ size = 44, wordSize = 22, className = '' }) => (
  <span className={`brand-lockup ${className}`.trim()}>
    <LedgerBug size={size} />
    <span className="brand-lockup__word" style={{ fontSize: `${wordSize}px` }}>
      <span>2 Girls</span>
      <span className="brand-lockup__one">1</span>
      <span>Parlay</span>
    </span>
  </span>
);

export default BrandLockup;
